// Components made available to all MDX content via MDXProvider.
// Imported by both gatsby-browser.js and gatsby-ssr.js.

import React from "react";
import MyArticleTable from "./components/cms/MyArticleTable";
import MyArticleImg from "./components/cms/MyArticleImg";
import MyArticleMore from "./components/cms/MyArticleMore";
import MyArticleMoreLeadUmow from "./components/cms/MyArticleMoreLeadUmow";
import YoutubePlayer from "./components/YoutubePlayer";
import YoutubeGif from "./components/YoutubeGif";

const hasWidederm = (text = "") =>
  String(text).toLocaleLowerCase().indexOf("wideoderm") !== -1;

export const mdxComponents = {
  img: MyArticleImg,
  More: MyArticleMore,
  MoreLeadUmow: MyArticleMoreLeadUmow,
  table: MyArticleTable,
  YoutubePlayer,
  YoutubeGif,
  h2: (props) => {
    const className = hasWidederm(props.children) ? "wideoderm" : "";
    return <h2 className={className} {...props} />;
  },
  h3: (props) => {
    const className = hasWidederm(props.children) ? "wideoderm" : "";
    return <h3 className={className} {...props} />;
  },
};
